import React from 'react';
import { findAll } from 'highlight-words-core';

export const formatOptionLabel = ({ label }, { inputValue }) => {
  const textToHighlight = label;

  const chunks = findAll({
    caseSensitive: false,
    textToHighlight,
    autoEscape: true,
    searchWords: [inputValue]
  });

  return (chunks || []).map((chunk) => {
    const { end, highlight, start } = chunk;
    const text = textToHighlight.substr(start, end - start);

    if (highlight) {
      return (
        <b key={text} id={text} style={{ fontWeight: 500 }} className='text-gray-900 heavier'>
          {text}
        </b>
      );
    }
    return (
      <span key={text} id={text} className='space-type-value'>
        {text}
      </span>
    );
  });
};
